{
  "familyId": "GET-PROC-BASIS",
  "questions": [
    {
      "id": "GET-PROC-BASIS-001",
      "familyId": "GET-PROC-BASIS",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "skill": "procenten",
      "subSkill": "proc_breuk_decimaal",
      "questionType": "multiple_choice",
      "question": "Een bakker verdeelt een taart in 4 gelijke stukken en verkoopt er 1. Welk percentage van de taart is verkocht?",
      "context": null,
      "options": [
        "25%",
        "50%",
        "10%",
        "75%"
      ],
      "correctAnswer": 0,
      "conceptId": "fraction_to_percent_quarter",
      "variantIndex": 1,
      "group": 6,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 4,
            "label": "1 van de 4 stukken verkocht",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 1,
            "denominator": 4,
            "label": "$\\frac{1}{4}$ = 25%: 1 deel van 4 gelijke delen",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "feedback": {
        "explanationText": "De bakker verdeelt de taart in 4 stukken en verkoopt er 1. Dat is $\\frac{1}{4}$ van de taart. Om een breuk naar procent om te rekenen, vermenigvuldig je met 100: $\\frac{1}{4}$ × 100 = 25%. Je kunt ook redeneren: 4 stukken = 100%, dus 1 stuk = 100% ÷ 4 = 25%.",
        "solutionSteps": [
          "Bepaal de breuk: 1 van de 4 stukken = $\\frac{1}{4}$",
          "Reken om naar procent: $\\frac{1}{4}$ × 100 = 25%",
          "Of: 100% ÷ 4 stukken = 25% per stuk"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{4}$ × 100 = 25%. Een kwart van de taart is verkocht.",
          "1": "Je dacht waarschijnlijk dat 1 van de 4 stukken de helft is. Maar de helft is 2 van de 4 stukken (50%). Bij 1 van de 4 stukken is het een kwart: $\\frac{1}{4}$ × 100 = 25%. Onthoud: de helft = $\\frac{2}{4}$ = 50%, een kwart = $\\frac{1}{4}$ = 25%.",
          "2": "Je dacht waarschijnlijk dat $\\frac{1}{4}$ = 10%. Maar $\\frac{1}{4}$ × 100 = 25%, niet 10%. 10% hoort bij $\\frac{1}{10}$ (een tiende). Onthoud: een kwart = 25%, een tiende = 10%.",
          "3": "Je dacht waarschijnlijk dat 3 van de 4 stukken verkocht zijn. Maar er is 1 stuk verkocht, niet 3. 75% = $\\frac{3}{4}$ = drie kwart. Onthoud: lees goed hoeveel stukken er verkocht zijn."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "get.kwart-helft-verward", "label": "Verwart 1/4 (25%) met 1/2 (50%)", "optionIndex": 1 },
          { "id": "get.kwart-tiende-verward", "label": "Verwart 1/4 (25%) met 1/10 (10%)", "optionIndex": 2 },
          { "id": "get.deel-rest-verward", "label": "Kiest 3/4 i.p.v. 1/4 (leest verkeerd)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "GET-PROC-BASIS-002",
      "familyId": "GET-PROC-BASIS",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "skill": "procenten",
      "subSkill": "proc_breuk_decimaal",
      "questionType": "multiple_choice",
      "question": "Een winkelier zet op een bord: '0,5 van de voorraad is uitverkocht.' Welk percentage is dat?",
      "context": null,
      "options": [
        "50%",
        "5%",
        "0,5%",
        "500%"
      ],
      "correctAnswer": 0,
      "conceptId": "decimal_to_percent_half",
      "variantIndex": 4,
      "group": 6,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 1,
            "denominator": 2,
            "label": "0,5 = $\\frac{1}{2}$ = 50%",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "feedback": {
        "explanationText": "De winkelier bedoelt dat de helft uitverkocht is. 0,5 = $\\frac{5}{10}$ = $\\frac{1}{2}$. Om een kommagetal naar procent om te rekenen, vermenigvuldig je met 100: 0,5 × 100 = 50%. Dus de helft van de voorraad (50%) is uitverkocht.",
        "solutionSteps": [
          "Herken het kommagetal: 0,5 = $\\frac{1}{2}$ (de helft)",
          "Reken om naar procent: vermenigvuldig met 100",
          "0,5 × 100 = 50%"
        ],
        "distractorExplanations": {
          "0": "Goed! 0,5 × 100 = 50%. De helft van de voorraad is uitverkocht.",
          "1": "Je dacht waarschijnlijk dat 0,5 dicht bij 0,05 ligt. Maar 0,05 = 5% en 0,5 = 50%. Dat is tien keer zo veel! Onthoud: 0,5 = de helft = 50%, 0,05 = een twintigste = 5%.",
          "2": "Je dacht waarschijnlijk dat 0,5 al een percentage is. Maar 0,5 is een kommagetal. Om het naar procent om te rekenen, vermenigvuldig je met 100: 0,5 × 100 = 50%. Onthoud: procent = kommagetal × 100.",
          "3": "Je dacht waarschijnlijk dat je 0,5 × 1000 doet. Maar je vermenigvuldigt met 100 (niet 1000): 0,5 × 100 = 50%. 500% zou meer zijn dan het geheel. Onthoud: procent = × 100."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "get.decimaal-komma-verschuiving", "label": "Verwart 0,5 met 0,05 (5%)", "optionIndex": 1 },
          { "id": "get.decimaal-is-procent", "label": "Denkt 0,5 al een percentage is (0,5%)", "optionIndex": 2 },
          { "id": "get.decimaal-keer-1000", "label": "Vermenigvuldigt met 1000 i.p.v. 100", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "GET-PROC-BASIS-003",
      "familyId": "GET-PROC-BASIS",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "skill": "procenten",
      "subSkill": "proc_breuk_decimaal",
      "questionType": "multiple_choice",
      "question": "Een leraar zegt: 'Van de 20 leerlingen in de klas zijn er 5 ziek.' Welk percentage van de klas is ziek?",
      "context": null,
      "options": [
        "25%",
        "5%",
        "50%",
        "20%"
      ],
      "correctAnswer": 0,
      "conceptId": "ratio_to_percent_class",
      "variantIndex": 5,
      "group": 6,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.75,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van deel naar procent",
            "content": "5 van de 20 = $\\frac{5}{20}$. Vereenvoudig: $\\frac{5}{20}$ = $\\frac{1}{4}$. Een kwart = 25%. Of: $\\frac{5}{20}$ × 100 = 25%.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De leraar telt: 5 van de 20 leerlingen zijn ziek. Schrijf als breuk: $\\frac{5}{20}$. Vereenvoudig: deel boven en onder door 5 → $\\frac{1}{4}$. Reken om naar procent: $\\frac{1}{4}$ × 100 = 25%. Of reken direct: $\\frac{5}{20}$ × 100 = 500 ÷ 20 = 25%. Dus 25% van de klas is ziek.",
        "solutionSteps": [
          "Schrijf als breuk: 5 van de 20 = $\\frac{5}{20}$",
          "Vereenvoudig: $\\frac{5}{20}$ = $\\frac{1}{4}$ (deel door 5)",
          "Reken om naar procent: $\\frac{1}{4}$ × 100 = 25%"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{5}{20}$ = $\\frac{1}{4}$ = 25% van de klas is ziek.",
          "1": "Je dacht waarschijnlijk dat het aantal (5) gelijk is aan het percentage. Maar 5 leerlingen van de 20 is niet 5%. Je moet het omrekenen: $\\frac{5}{20}$ × 100 = 25%. Onthoud: het aantal is niet hetzelfde als het percentage.",
          "2": "Je dacht waarschijnlijk dat 5 van de 20 de helft is. Maar de helft van 20 is 10, niet 5. 5 van de 20 = een kwart = 25%. Onthoud: de helft = 50%, een kwart = 25%.",
          "3": "Je dacht waarschijnlijk dat het totaal (20) het percentage is. Maar 20 is het totale aantal leerlingen, niet het percentage. Het percentage is $\\frac{5}{20}$ × 100 = 25%. Onthoud: het totaal is altijd 100%."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.aantal-is-procent", "label": "Denkt aantal (5) = percentage (5%)", "optionIndex": 1 },
          { "id": "get.deel-helft-verward", "label": "Verwart 5/20 met de helft (50%)", "optionIndex": 2 },
          { "id": "get.totaal-is-procent", "label": "Denkt totaal (20) = percentage (20%)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "GET-PROC-BASIS-004",
      "familyId": "GET-PROC-BASIS",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "skill": "procenten",
      "subSkill": "proc_breuk_decimaal",
      "questionType": "multiple_choice",
      "question": "Een sportcoach zegt: '75% van het team was aanwezig bij de training.' Het team heeft 20 spelers. Hoeveel spelers waren er?",
      "context": null,
      "options": [
        "15 spelers",
        "75 spelers",
        "7 spelers",
        "5 spelers"
      ],
      "correctAnswer": 0,
      "conceptId": "percent_of_amount_team",
      "variantIndex": 6,
      "group": 6,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.73,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Percentage van een aantal",
            "content": "75% van 20 = $\\frac{75}{100}$ × 20 = $\\frac{3}{4}$ × 20 = 15. Of: 75% = drie kwart. Een kwart van 20 = 5. Drie kwart = 3 × 5 = 15.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De sportcoach wil weten: 75% van 20 spelers = hoeveel? 75% = $\\frac{75}{100}$ = $\\frac{3}{4}$ (drie kwart). Bereken: $\\frac{3}{4}$ × 20 = 60 ÷ 4 = 15 spelers. Of splits het op: 25% van 20 = 5 (een kwart). 75% = 3 × 25% = 3 × 5 = 15 spelers.",
        "solutionSteps": [
          "75% = $\\frac{3}{4}$ (drie kwart)",
          "Bereken een kwart: 20 ÷ 4 = 5 spelers",
          "Drie kwart: 3 × 5 = 15 spelers"
        ],
        "distractorExplanations": {
          "0": "Goed! 75% van 20 = $\\frac{3}{4}$ × 20 = 15 spelers.",
          "1": "Je dacht waarschijnlijk dat 75% = 75 spelers. Maar het team heeft maar 20 spelers — 75 is meer dan het hele team! 75% betekent 75 van de 100, oftewel drie kwart. Drie kwart van 20 = 15. Onthoud: 75% ≠ 75 stuks.",
          "2": "Je dacht waarschijnlijk dat je 75 ÷ 10 doet. Maar 75% van 20 = $\\frac{3}{4}$ × 20 = 15, niet 7,5 (afgerond 7). Onthoud: 75% = drie kwart, dus deel door 4 en vermenigvuldig met 3.",
          "3": "Je dacht waarschijnlijk dat 75% een kwart is. Maar een kwart = 25%, niet 75%. 25% van 20 = 5 spelers. 75% = drie kwart = 15 spelers. Onthoud: 25% = een kwart, 75% = drie kwart."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.procent-is-aantal", "label": "Denkt 75% = 75 stuks", "optionIndex": 1 },
          { "id": "get.procent-deel-10", "label": "Deelt 75 door 10 (≈7)", "optionIndex": 2 },
          { "id": "get.driekwart-kwart-verward", "label": "Verwart 75% (3/4) met 25% (1/4)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "GET-PROC-BASIS-005",
      "familyId": "GET-PROC-BASIS",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "skill": "procenten",
      "subSkill": "proc_breuk_decimaal",
      "questionType": "fill_in",
      "question": "Een dierenarts behandelt op een dag 20 dieren. Daarvan zijn er 4 katten. Welk percentage van de dieren is een kat?",
      "context": null,
      "correctAnswer": "20",
      "data": {
        "acceptedAnswers": ["20", "20%", "20 %", "20 procent"],
        "caseSensitive": false,
        "placeholder": "...%"
      },
      "conceptId": "ratio_to_percent_fill_in",
      "variantIndex": 7,
      "group": 6,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 4,
            "denominator": 20,
            "label": "4 van de 20 dieren zijn katten",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van deel naar procent",
            "content": "4 van de 20 = $\\frac{4}{20}$. Vereenvoudig: $\\frac{4}{20}$ = $\\frac{1}{5}$. Een vijfde = 20%. Of: $\\frac{4}{20}$ × 100 = 400 ÷ 20 = 20%.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De dierenarts behandelt 20 dieren, waarvan 4 katten. Schrijf als breuk: $\\frac{4}{20}$. Vereenvoudig: deel boven en onder door 4 → $\\frac{1}{5}$. Reken om naar procent: $\\frac{1}{5}$ × 100 = 20%. Je kunt ook direct rekenen: $\\frac{4}{20}$ × 100 = 400 ÷ 20 = 20%. Dus 20% van de dieren is een kat.",
        "solutionSteps": [
          "Schrijf als breuk: 4 van de 20 = $\\frac{4}{20}$",
          "Vereenvoudig: $\\frac{4}{20}$ = $\\frac{1}{5}$ (deel door 4)",
          "Reken om naar procent: $\\frac{1}{5}$ × 100 = 20%"
        ],
        "distractorExplanations": {}
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "GET-PROC-BASIS-006",
      "familyId": "GET-PROC-BASIS",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "skill": "procenten",
      "subSkill": "proc_breuk_decimaal",
      "questionType": "true_false_series",
      "question": "Zijn deze beweringen over procenten, breuken en kommagetallen waar of onwaar?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "$\\frac{1}{2}$ is hetzelfde als 50%.", "isTrue": true },
          { "text": "0,25 is hetzelfde als 25%.", "isTrue": true },
          { "text": "$\\frac{3}{4}$ is hetzelfde als 34%.", "isTrue": false },
          { "text": "0,1 is hetzelfde als 1%.", "isTrue": false }
        ]
      },
      "conceptId": "percent_fraction_decimal_tf",
      "variantIndex": 8,
      "group": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Procent, breuk en kommagetal",
            "content": "Kommagetal → procent: vermenigvuldig met 100. Breuk → procent: deel teller door noemer, dan ×100. Voorbeelden: $\\frac{1}{2}$ = 0,5 = 50%. $\\frac{1}{4}$ = 0,25 = 25%. $\\frac{3}{4}$ = 0,75 = 75%. 0,1 = $\\frac{1}{10}$ = 10%.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Stelling 1: Waar — $\\frac{1}{2}$ = 0,5, en 0,5 × 100 = 50%. Stelling 2: Waar — 0,25 × 100 = 25%. Stelling 3: Onwaar — $\\frac{3}{4}$ = 0,75 = 75%, niet 34%. De 3 en 4 zijn geen losse cijfers! Stelling 4: Onwaar — 0,1 × 100 = 10%, niet 1%. 1% = 0,01.",
        "solutionSteps": [
          "$\\frac{1}{2}$ = 0,5 → 0,5 × 100 = 50% (Waar)",
          "0,25 × 100 = 25% (Waar)",
          "$\\frac{3}{4}$ = 0,75 → 0,75 × 100 = 75%, niet 34% (Onwaar)",
          "0,1 × 100 = 10%, niet 1% (Onwaar)"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "GET-PROC-BASIS-007",
      "familyId": "GET-PROC-BASIS",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "skill": "procenten",
      "subSkill": "proc_breuk_decimaal",
      "questionType": "categorize",
      "question": "Sorteer deze waarden bij het juiste percentage.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["25%", "50%", "75%"],
        "items": [
          { "text": "$\\frac{1}{4}$", "correctCategory": 0 },
          { "text": "0,5", "correctCategory": 1 },
          { "text": "$\\frac{3}{4}$", "correctCategory": 2 },
          { "text": "0,25", "correctCategory": 0 },
          { "text": "$\\frac{1}{2}$", "correctCategory": 1 },
          { "text": "0,75", "correctCategory": 2 }
        ]
      },
      "conceptId": "percent_fraction_decimal_categorize",
      "variantIndex": 9,
      "group": 6,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Procent, breuk en kommagetal koppelen",
            "content": "25% = $\\frac{1}{4}$ = 0,25 (een kwart). 50% = $\\frac{1}{2}$ = 0,5 (de helft). 75% = $\\frac{3}{4}$ = 0,75 (drie kwart). Tip: vermenigvuldig het kommagetal met 100 om het percentage te vinden.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "25% = $\\frac{1}{4}$ = 0,25 (een kwart). 50% = $\\frac{1}{2}$ = 0,5 (de helft). 75% = $\\frac{3}{4}$ = 0,75 (drie kwart). Deze drie vormen (procent, breuk, kommagetal) zijn verschillende manieren om hetzelfde getal te schrijven.",
        "solutionSteps": [
          "25% = $\\frac{1}{4}$ = 0,25",
          "50% = $\\frac{1}{2}$ = 0,5",
          "75% = $\\frac{3}{4}$ = 0,75"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "GET-PROC-BASIS-008",
      "familyId": "GET-PROC-BASIS",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "skill": "procenten",
      "subSkill": "proc_breuk_decimaal",
      "questionType": "grid_shade",
      "question": "Arceer 75% van het veld. Klik op de vakjes om ze te kleuren.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "gridShade": {
          "gridRows": 5,
          "gridCols": 4,
          "targetCount": 15,
          "mode": "shade_fraction",
          "preShaded": [],
          "showCounter": false
        }
      },
      "conceptId": "shade_percent_75_grid",
      "variantIndex": 10,
      "group": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "75% van een veld",
            "content": "Het veld heeft 20 vakjes. 75% is drie kwart (3/4). Een kwart van 20 is 5. Drie kwart is 3 × 5 = 15 vakjes.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het veld heeft 20 vakjes. 75% = 3/4 (drie kwart). Een kwart van 20 is 5 vakjes. Drie kwart is 3 × 5 = 15 vakjes. Je moest dus 15 vakjes kleuren.",
        "solutionSteps": [
          "Tel het totaal aantal vakjes: 5 × 4 = 20",
          "75% = 3/4 (drie kwart)",
          "1/4 van 20 = 5",
          "3/4 van 20 = 15 vakjes"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "GET-PROC-BASIS-009",
      "familyId": "GET-PROC-BASIS",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "skill": "procenten",
      "subSkill": "proc_breuk_decimaal",
      "questionType": "grid_shade",
      "question": "Maak het af zodat precies 50% van het veld gekleurd is.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "gridShade": {
          "gridRows": 4,
          "gridCols": 5,
          "targetCount": 10,
          "mode": "shade_fraction",
          "preShaded": [0, 1, 2, 3],
          "showCounter": true
        }
      },
      "conceptId": "shade_percent_50_grid",
      "variantIndex": 11,
      "group": 6,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "50% van een veld",
            "content": "Het veld heeft 20 vakjes. 50% is de helft. De helft van 20 is 10. Er zijn al 4 vakjes gekleurd, dus je moet er nog 6 bij kleuren.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het veld heeft 20 vakjes. 50% is de helft, dus 10 vakjes in totaal. Er waren al 4 vakjes gekleurd, dus je moest er nog 6 bij kleuren om op 10 te komen.",
        "solutionSteps": [
          "Tel het totaal aantal vakjes: 4 × 5 = 20",
          "50% is de helft: 10 vakjes",
          "Er zijn al 4 gekleurd",
          "Kleur er nog 6 bij (totaal 10)"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "GET-PROC-BASIS-010",
      "familyId": "GET-PROC-BASIS",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "skill": "procenten",
      "subSkill": "proc_breuk_decimaal",
      "questionType": "multiple_choice",
      "question": "Bekijk de percentagebalk. Welke breuk hoort bij het getoonde percentage?",
      "context": null,
      "options": [
        "$\\frac{3}{4}$",
        "$\\frac{1}{4}$",
        "$\\frac{2}{3}$",
        "$\\frac{7}{10}$"
      ],
      "correctAnswer": 0,
      "conceptId": "percent_to_fraction_bar_75",
      "variantIndex": 12,
      "group": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 75,
            "label": "Hoeveel is dit als breuk?",
            "showValue": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "percentageBar",
          "showWhen": "wrong",
          "data": {
            "percentage": 75,
            "label": "75% = ¾ van het geheel",
            "showValue": true
          }
        }
      ],
      "feedback": {
        "explanationText": "De balk toont 75%. Om dit naar een breuk om te rekenen: 75 van de 100 = $\\frac{75}{100}$. Vereenvoudig door beide door 25 te delen: $\\frac{75 ÷ 25}{100 ÷ 25}$ = $\\frac{3}{4}$. Onthoud: 75% = drie kwart.",
        "solutionSteps": [
          "Lees het percentage af: 75%",
          "Schrijf als breuk: $\\frac{75}{100}$",
          "Vereenvoudig: $\\frac{75}{100}$ = $\\frac{3}{4}$",
          "Check: $\\frac{3}{4}$ × 100 = 75% ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 75% = $\\frac{75}{100}$ = $\\frac{3}{4}$. Drie kwart van de balk is gevuld.",
          "1": "Je verwisselde 75% met 25%. $\\frac{1}{4}$ = 25%, niet 75%. Kijk goed naar de balk: driekwart is gevuld, dus $\\frac{3}{4}$.",
          "2": "$\\frac{2}{3}$ ≈ 66,7%, niet 75%. De balk toont duidelijk meer dan twee derde. 75% = $\\frac{3}{4}$.",
          "3": "$\\frac{7}{10}$ = 70%, niet 75%. Het verschil is klein, maar kijk naar de 75%-markering op de balk. 75% = $\\frac{3}{4}$."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.percent-fraction-swap", "label": "75% en 25% verwisseld", "optionIndex": 1 },
          { "id": "get.percent-fraction-approx", "label": "Breuk bij benadering gekozen", "optionIndex": 2 },
          { "id": "get.percent-fraction-close", "label": "Dichtbij percentage maar verkeerde breuk", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "GET-PROC-BASIS-011",
      "familyId": "GET-PROC-BASIS",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "skill": "procenten",
      "subSkill": "proc_breuk_decimaal",
      "questionType": "fill_in",
      "question": "Een winkel geeft 20% korting op een jas van €80. Hoeveel euro korting krijg je?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["16", "€16", "€ 16", "16,00", "€16,00"]
      },
      "conceptId": "percent_of_amount_20",
      "variantIndex": 13,
      "group": 6,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.68,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "percentageBar",
          "showWhen": "wrong",
          "data": {
            "percentage": 20,
            "percentageLabel": "Korting: 20%",
            "comparePercentage": 100,
            "compareLabel": "Originele prijs: €80",
            "label": "20% van €80 = €16",
            "showValue": true
          }
        }
      ],
      "feedback": {
        "explanationText": "20% van €80 bereken je zo: $\\frac{20}{100}$ × 80 = 0,20 × 80 = €16. Je kunt ook eerst 10% berekenen (€8) en dat verdubbelen: 2 × €8 = €16.",
        "solutionSteps": [
          "Bepaal het percentage: 20%",
          "Reken 10% uit: €80 ÷ 10 = €8",
          "20% = 2 × 10% = 2 × €8 = €16",
          "Check: €16 van €80 = $\\frac{16}{80}$ = $\\frac{1}{5}$ = 20% ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "GET-PROC-BASIS-012",
      "familyId": "GET-PROC-BASIS",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "skill": "procenten",
      "subSkill": "proc_breuk_decimaal",
      "questionType": "true_false_series",
      "question": "Bekijk de twee percentagebalken. Beoordeel de stellingen.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "De bovenste balk toont meer dan de helft", "isTrue": true },
          { "text": "Het verschil tussen de twee balken is 20%", "isTrue": false },
          { "text": "De onderste balk toont een kwart", "isTrue": true },
          { "text": "60% is meer dan $\\frac{1}{2}$", "isTrue": true }
        ]
      },
      "conceptId": "percent_compare_bars_tf",
      "variantIndex": 14,
      "group": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 60,
            "percentageLabel": "Balk A",
            "comparePercentage": 25,
            "compareLabel": "Balk B",
            "label": "Vergelijk de twee balken",
            "showValue": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Percentages vergelijken",
            "content": "Balk A = 60%, balk B = 25%. De helft = 50%. 60% > 50% ✓. Verschil: 60% − 25% = 35%, niet 20%. 25% = $\\frac{1}{4}$ = een kwart ✓.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Balk A toont 60% en balk B toont 25%. 60% > 50% (de helft), dus stelling 1 is waar. Het verschil is 60% − 25% = 35%, niet 20%, dus stelling 2 is onwaar. 25% = $\\frac{1}{4}$ = een kwart, dus stelling 3 is waar. 60% > $\\frac{1}{2}$ = 50%, dus stelling 4 is waar.",
        "solutionSteps": [
          "Balk A = 60%, balk B = 25%",
          "60% > 50% (de helft) → stelling 1 is WAAR",
          "60% − 25% = 35% ≠ 20% → stelling 2 is ONWAAR",
          "25% = $\\frac{25}{100}$ = $\\frac{1}{4}$ → stelling 3 is WAAR",
          "60% > 50% = $\\frac{1}{2}$ → stelling 4 is WAAR"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "GET-PROC-BASIS-DNL-001",
      "familyId": "GET-PROC-BASIS",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "procenten",
      "subSkill": "proc_breuk_decimaal",
      "questionType": "double_number_line",
      "question": "Een telefoonbatterij is voor 50% opgeladen. De volle batterij gaat 40 uur mee. Sleep de stip naar het juiste aantal uur.",
      "context": null,
      "options": [],
      "correctAnswer": 20,
      "data": {
        "doubleNumberLine": {
          "topScale": { "min": 0, "max": 100, "unit": "%", "label": "procent" },
          "bottomScale": { "min": 0, "max": 40, "unit": "u", "label": "uur" },
          "knownPoints": [
            { "top": 0, "bottom": 0 },
            { "top": 100, "bottom": 40 }
          ],
          "askFor": "bottom",
          "correctValue": 20,
          "tolerancePercent": 5,
          "promptLabel": "Hoeveel uur is 50% van 40 uur?"
        }
      },
      "conceptId": "double_number_line_half",
      "variantIndex": 9,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.80,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "50% = de helft",
            "content": "50% is precies de helft van 100%. Als 100% = 40 uur, dan is 50% = 40 ÷ 2 = 20 uur. Op de dubbele getallenlijn zit 50% precies in het midden tussen 0% en 100%.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "50% is de helft. Op de dubbele getallenlijn zit 50% in het midden van 0% en 100%. Bij 100% hoort 40 uur, dus bij 50% hoort de helft: 40 ÷ 2 = 20 uur.",
        "solutionSteps": [
          "Lees af: 100% = 40 uur",
          "50% is de helft van 100%",
          "Helft van 40 uur = 20 uur",
          "Sleep de stip naar 20 uur"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "hasStructuredData": true
      }
    }
  ]
}